import { groupBy, orderBy } from "lodash";
import { Item__Atividades } from "../../../../../../../services/atividades/GET";
import { obterCodInsumoDashboard, obterNomeMediaLocal } from "../../insumosPrecisao/meta";

function normarlizarQtdeBiologico(quantidade: number, cod_medida: number, medida_biologico: string) {
    const medida_bio = String(medida_biologico)?.toLowerCase()?.replace('/ha', '');

    //já está em L
    if (medida_bio === 'ml' || medida_bio === 'l') {
        if (cod_medida === 1) {
            return { quantidade, medida: 'L', tipo_fisico: 'Líquido' };
        }

        //transformar mL em L
        if (cod_medida === 2) {
            return { quantidade: quantidade / 1000, medida: 'L', tipo_fisico: 'Líquido' };
        }
    }

    if (medida_bio === 'kg' || medida_bio === 'g') {
        if (cod_medida === 3 || cod_medida === 6) {
            return { quantidade, medida: 'kg', tipo_fisico: 'Sólido' };
        }
        //transformar g em kg
        if (cod_medida === 4) {
            return { quantidade: quantidade / 1000, medida: 'kg', tipo_fisico: 'Sólido' };
        }
    }

    //TODO
    //precisa tratar quando a medida for dose/ha

    return { quantidade: 0, medida: '' };
}

export function obterListaBiologicos(todas_atividades_ativas: Item__Atividades[]): {
    cod_insumo: number,
    insumo_nome: string;
    quantidade_planejada: number;
    quantidade_executada: number;
    precisao: number;
    porcentagem: number;
    tipo_fisico: string;
    ordem: number;
}[] {

    const incluir_tipo_atv = (todas_atividades_ativas ?? []).map(i => {
        return {
            ...i, andamentos: (i.andamentos ?? []).map(j => {
                return {
                    ...j, insumos: (j.insumos ?? []).map(k => {
                        return {
                            ...k,
                            tipo_atividade: i.cod_tipo === 1 ? "planejada" : "executada",
                            cod_tipo_atividade: i.cod_tipo
                        }
                    })
                }
            })
        }
    }).filter(i => i.delete_time === null);


    const apenas_insumos = (incluir_tipo_atv ?? []).map(i => {
        return i.andamentos.map(j => {
            return (j.insumos ?? []).map(k => {
                return {
                    cod: k.cod,
                    insumo_nome: k.insumo_nome,
                    cod_produto: k.cod_produto,
                    cod_fertilizante: k.cod_fertilizante,
                    cod_tecnologia: k.cod_tecnologia,
                    cod_variedade_hibrido: k.cod_variedade_hibrido,
                    cod_tipo: k.cod_tipo,
                    cod_tipo_atividade: k.cod_tipo_atividade,
                    composicao: k.composicao,
                    cod_medida: k.cod_medida,
                    dosagem: k.dosagem,
                    maximo_abaixo: k.maximo_abaixo,
                    maximo_acima: k.maximo_acima,
                    quantidade: k.quantidade,
                    tipo_atividade: k.tipo_atividade,
                    nome_medida_filtro: obterNomeMediaLocal(k.cod_medida).nome_filtro,
                    tipo_fisico_medida: obterNomeMediaLocal(k.cod_medida).tipo_fisico,
                    cod_insumo: obterCodInsumoDashboard(k)
                }
            })
        })
        //@ts-ignore
    }).flat(2)?.filter(i => i.cod_tipo === 9);

    const incluir_qtd_normalizada = (apenas_insumos ?? []).map(i => {
        return {
            ...i,
            quantidade_em_litros: normarlizarQtdeBiologico(i.quantidade, i.cod_medida, i.nome_medida_filtro)?.quantidade,
            medida_biologico_normalizada: normarlizarQtdeBiologico(i.quantidade, i.cod_medida, i.nome_medida_filtro)?.medida,
            nome_biologico_agrupar: `${i.insumo_nome} (${normarlizarQtdeBiologico(i.quantidade, i.cod_medida, i.nome_medida_filtro)?.tipo_fisico})`
        }
    });

    const insumos_planejados = (incluir_qtd_normalizada ?? []).filter(({ tipo_atividade }) => tipo_atividade === "planejada");
    const insumos_executados = (incluir_qtd_normalizada ?? []).filter(({ tipo_atividade }) => tipo_atividade === "executada");

    const agrupar_insumos_planejados = groupBy(insumos_planejados, "nome_biologico_agrupar");
    const agrupar_insumos_executados = groupBy(insumos_executados, "nome_biologico_agrupar");

    const totalizar_planejados = Object.entries(agrupar_insumos_planejados).map(([insumo_nome, insumos]) => {
        return {
            insumo_nome,
            quantidade: insumos.reduce((total, insumo) => total + insumo.quantidade_em_litros, 0)
        }
    });

    const totalizar_executados = Object.entries(agrupar_insumos_executados).map(([insumo_nome, insumos]) => {
        return {
            insumo_nome,
            quantidade: insumos.reduce((total, insumo) => total + insumo.quantidade_em_litros, 0)
        }
    });

    const insumos_consolidados: {
        cod_insumo: number;
        insumo_nome: string;
        quantidade_planejada: number;
        quantidade_executada: number;
        precisao: number;
        porcentagem: number;
        ordem: number;
        tipo_fisico: string;
    }[] = [];

    // Combine planned and executed data
    const todos_insumos = new Set([...totalizar_planejados.map(i => i.insumo_nome), ...totalizar_executados.map(i => i.insumo_nome)]);

    todos_insumos.forEach(insumo_nome => {
        const primeiro_insumo = (agrupar_insumos_planejados[insumo_nome] || agrupar_insumos_executados[insumo_nome])?.[0];
        const cod_insumo = primeiro_insumo?.cod_insumo || null;

        const planejado = totalizar_planejados.find(i => i.insumo_nome === insumo_nome)?.quantidade || 0;
        const executado = totalizar_executados.find(i => i.insumo_nome === insumo_nome)?.quantidade || 0;

        let precisao = 0;
        let porcentagem = 0;

        if (planejado > 0) {
            const porcentagem_realizada = (executado / planejado) * 100;

            // Precision: 100 - |100 - executed%|
            // Represents how close the execution was to the plan (0-100%)
            precisao = 100 - Math.abs(100 - porcentagem_realizada);
            if (precisao < 0) precisao = 0;

            // Bar Percentage: Visual representation of execution.
            // As per user request: "não precisa compensar os 80%, pode exibir o valor real mesmo"
            // Example: 105% executed -> 105% bar.
            porcentagem = porcentagem_realizada;

        } else if (executado > 0) {
            precisao = 0;
            // Unplanned execution -> Percentage and Precision must be 0 as per user request.
            porcentagem = 0;
        }

        insumos_consolidados.push({
            cod_insumo,
            insumo_nome: insumo_nome?.replace(/\(([^)]+)\)/, '')?.replace(/\[([^\]]+)\]/, '')?.trim(),
            quantidade_planejada: Number(planejado?.toFixed(2)),
            quantidade_executada: Number(executado?.toFixed(2)),
            precisao: Number(precisao?.toFixed(2)),
            porcentagem: Number(porcentagem?.toFixed(2)),
            tipo_fisico: insumo_nome?.match(/\(([^)]+)\)/)?.[1] ?? '',
            ordem: (planejado > 0 && executado > 0) ? 1 : (planejado === 0 && executado > 0) ? 2 : (planejado > 0 && executado === 0) ? 3 : 4
        });
    });

    return orderBy(insumos_consolidados, ["ordem", "quantidade_executada"], ["asc", "desc"]) ?? [];

}